import request from "@/util/request.js";
export const login = (tenantId, username, password) =>
  request({
    url: "api/sansint-auth/oauth/token",
    method: "post",
    headers: {
      "Tenant-Id": tenantId,
      userType: 0,
      "User-Type": "app"
    },
    params: {
      tenantId,
      username,
      password,
      grant_type: "password",
      scope: "all"
    }
  });
